<footer class="footer">
    Todos los derechos reservados, Claro 2025
</footer>
<div id="overlay" [class.overlayUp]="mobileMenu.estado === 'abriendo'" (click)="mobileMenu.cerrar()"></div>